module.exports = __webpack_public_path__ + "assets/pdf/E07-cn-high-resolution.3755b9c5.pdf";